'use strict';

/**
 * nav
 */
export const viewPos = (() => {
    const $vPos = $('.js-viewPos');
    const $vPosPt = $('.js-viewPosPt');
    let vPt = -1;

    const scrJudge = () => {
        if (!$('.is-show-nav').length) {
            vPt = -1;

            $vPosPt.each((index, element) => {
                const $this = $(element);

                if ($this.hasClass('is-inview')) {
                    vPt++
                }
            });

            $vPos.removeClass('is-current')

            if(vPt > -1) {
                $vPos.eq(vPt).addClass('is-current')
            }
        }
    }

    const init = () => {
        $(window).on('load resize scroll', function () {
            setTimeout(() => {
                scrJudge();
            }, 10);
        });
    };

    return {
        init: init
    };
})();
